module.exports = new __parcel__URL__("shadowblow.59a6683a.png").toString();